import request from '@/utils/request'
import queryString from 'querystring'

// 竞价交易 - 关注竞价
export function bidFocus(data) {
  return request({
    url: '/client/mine/bid/focus',
    method: 'post',
    data:queryString.stringify(data)
  })
}

// 竞价交易 - 取消关注竞价
export function unbidFocus(data) {
  return request({
    url: '/client/mine/bid/cancel/focus',
    method: 'post',
    data:queryString.stringify(data)
  })
}

// 收藏成果
export function techCollect(data) {
  return request({
    url: '/client/mine/collect/tech',
    method: 'post',
    data:queryString.stringify(data)
  })
}

// 取消收藏成果
export function unTechCollect(data) {
  return request({
    url: '/client/mine/collect/tech/cancel',
    method: 'post',
    data:queryString.stringify(data)
  })
}

// 收藏会员单位
export function vipCollect(data) {
  return request({
    url: '/client/mine/collect/vip',
    method: 'post',
    data:queryString.stringify(data)
  })
}

// 取消收藏会员单位
export function unVipCollect(data) {
  return request({
    url: '/client/mine/collect/vip/cancel',
    method: 'post',
    data:queryString.stringify(data)
  })
}

// 收藏活动
export function actionCollect(data) {
  return request({
    url: '/client/mine/collect/action',
    method: 'post',
    data:queryString.stringify(data)
  })
}

// 取消收藏活动
export function unActionCollect(data) {
  return request({
    url: '/client/mine/collect/action/cancel',
    method: 'post',
    data:queryString.stringify(data)
  })
}

// 收藏政策
export function policyCollect(data) {
  return request({
    url: '/client/mine/collect/policy',
    method: 'post',
    data:queryString.stringify(data)
  })
}

// 取消政策
export function unPolicyCollect(data) {
  return request({
    url: '/client/mine/collect/policy/cancel',
    method: 'post',
    data:queryString.stringify(data)
  })
}

// 收藏会员技术悬赏
export function rewardCollect(data) {
  return request({
    url: '/client/mine/collect/reward',
    method: 'post',
    data:queryString.stringify(data)
  })
}

// 取消收藏技术悬赏
export function unRewardCollect(data) {
  return request({
    url: '/client/mine/collect/reward/cancel',
    method: 'post',
    data:queryString.stringify(data)
  })
}